/* eslint-disable eqeqeq */
import React from "react";
import { Button, Upload, Space } from "antd";
import * as XLSX from "xlsx";
import { ReplicarUnidadMedida } from "../../../atc/servicios-oma/cadenas-custodia/modals/ReplicarUnidadMedida";
import { BasePage } from "../../../../framework/pages/BasePage";
import BarButtonFw, {
  BUTTON_DEFAULT,
} from "../../../../framework/bar-button/BarButtonFw";
import { ICON } from "../../../../constants/iconConstants";
import GridFw from "../../../../framework/grid/GridFw";
import { ModalContext } from "../../../../provider/ModalProvider";

export class SubparametroResultadosRadiacionNoAcreModal extends BasePage {
  static contextType = ModalContext;

  createPageProperties = (pageApi) => {
    return {
      title: "Ingreso de Resultados",
    };
  };

  renderPage(pageApi) {
    const getGridParametros = () => pageApi.getComponent("parametrosGrid");

    const barHeaderConfig = {
      fields: [
        { ...BUTTON_DEFAULT.SAVE, onClick: () => getGridParametros().save() },
        { ...BUTTON_DEFAULT.RETURN, onClick: () => this.context.hideModal() },
      ],
    };

    const evaluacion_aritmetica_incertidumbre_ma = (fn) => {
      // eslint-disable-next-line no-new-func
      return new Function("return " + fn)();
    };

    const esValidoNumero = (value) => {
      const esNumero = /^-?\d+([.,]?\d+)?$/.test(value);
      return esNumero && parseFloat(value.replace(",", "."));
    };

    const calcResultRadiacion = (values) => {
      let { dividendo, divisor } = values;

      if (!parseFloat(dividendo) || !parseFloat(divisor)) return null;

      let result = dividendo * divisor;

      return isNaN(result) && result ? null : result;
    };

    function evaluarFormulasDinamico(formulas, subparametros, datosBase) {
      const resultados = { ...datosBase };

      // Cargar subparámetros iniciales
      for (const sp of subparametros) {
        const nombre = sp.sub_parametro?.trim();
        const id = sp.id_sub_parametro;
        const valor = parseFloat(sp.resultado);
        if (!isNaN(valor)) {
          resultados[nombre] = valor;
          resultados[id] = valor;
        }
      }

      // Detectar dependencias limpias
      const deps = formulas.map((f) => {
        const vars = [
          ...f.operacion.matchAll(/var\(([^()]*(?:\([^()]*\)[^()]*)*)\)/g),
        ].map((m) => m[1].trim().replace(/\s+/g, " "));
        return { ...f, deps: vars };
      });
      const pendientes = new Set(deps.map((f) => f.ana_nombre));
      let progreso = true;
      let iteraciones = 0;

      while (
        pendientes.size > 0 &&
        progreso &&
        iteraciones < formulas.length * 3
      ) {
        iteraciones++;
        progreso = false;

        for (const f of deps) {
          if (!pendientes.has(f.ana_nombre)) continue;

          const listo = f.deps.every((d) => resultados[d] !== undefined);
          if (!listo) continue;

          let expresion = f.operacion.replace(/\s*\|\s*/g, "");
          expresion = expresion.replace(
            /var\(([^()]*(?:\([^()]*\)[^()]*)*)\)/g,
            (_, v) => {
              const key = v.trim();
              const valor = resultados[key];
              if (valor === undefined) {
                console.warn(`Variable "${key}" no encontrada`);
                return 0;
              }
              return valor;
            },
          );

          try {
            // eslint-disable-next-line no-eval
            const valor = eval(expresion);

            resultados[f.ana_nombre] = valor;
            resultados[f.ana_id] = valor;
            pendientes.delete(f.ana_nombre);
            progreso = true;
          } catch (e) {
            console.error(`Error en fórmula ${f.ana_nombre}:`, expresion, e);
          }
        }
      }

      if (pendientes.size > 0) {
        console.warn("Las siguientes fórmulas no se pudieron resolver:", [
          ...pendientes,
        ]);
      }

      return resultados;
    }

    const ConfiguracionModalConfig = (data) => {
      let obj = {};
      obj = { ...obj, data };
      return {
        width: 800,
        maskClosable: false,
        component: (
          <ReplicarUnidadMedida
            name={obj}
            getParentApi={pageApi.getApi}
            idMetodo={0}
          />
        ),
      };
    };

    const obtenerCondicion = (data, value) => {
      const val = parseFloat(value);
      // eslint-disable-next-line array-callback-return
      return data.findIndex((el) => {
        if (el.IdTipo_Condicion == 1 && el.Valor_1 >= val) return el;
        else if (
          el.IdTipo_Condicion == 2 &&
          el.Valor_1 <= val &&
          el.Valor_2 >= val
        )
          return el;
        else if (el.IdTipo_Condicion == 3 && el.Valor_1 <= val) return el;
      });
    };

    const propsFile = {
      name: "file",
      accept: ".xlsx, .xlx",
      showUploadList: false,
      beforeUpload: async (file) => {
        await getGridParametros().saveItemEditing();
        await getGridParametros().refresh();
        var reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = (e) => {
          const bufferArray = e.target.result;
          const workbook = XLSX.read(bufferArray, {
            type: "binary",
            cellText: false,
            cellDates: true,
          });
          const { SheetNames, Sheets } = workbook;
          const sheetName = SheetNames[0];
          const woorSheet = Sheets[sheetName];
          const data_file = XLSX.utils.sheet_to_json(woorSheet, {
            header: 1,
            defval: "",
            raw: false,
            dateNF: "yyyy-mm-dd",
          });

          getGridParametros()
            .getData()
            .forEach((x, index) => {
              if (data_file[index] != undefined) {
                const resultado =
                  data_file[index][0] == undefined || data_file[index][0] == ""
                    ? ""
                    : data_file[index][0].includes("<") == true
                      ? "<" +
                        parseFloat(
                          data_file[index][0].replace("<", ""),
                        ).toFixed(x.cantidad_decimales)
                      : data_file[index][0].includes(">") == true
                        ? ">" +
                          parseFloat(
                            data_file[index][0].replace(">", ""),
                          ).toFixed(x.cantidad_decimales)
                        : parseFloat(data_file[index][0]).toFixed(
                            x.cantidad_decimales,
                          );

                const condiciones = JSON.parse(x.condicion_criterio);
                const indexFind = obtenerCondicion(
                  JSON.parse(x.condicion_criterio),
                  resultado,
                );
                const valIncert =
                  // eslint-disable-next-line eqeqeq
                  data_file[index][0].toLowerCase() == "nd"
                    ? "N.A."
                    : esValidoNumero(parseFloat(resultado))
                      ? condiciones[indexFind]?.Resultado
                      : "";
                getGridParametros().updateItem({
                  ...x,
                  incertidumbre: valIncert,
                  resultado: esValidoNumero(parseFloat(resultado))
                    ? resultado
                    : data_file[index][0],
                });
              }
            });
          getGridParametros().refresh();
          // getGridParametros().setData(replicar);
        };
        return false;
      },
    };

    const gridConfig = {
      rowId: "id_cadena_subparametro",
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      load: {
        queryId: 937,
        params: () => {
          return {
            id_parametro: pageApi?.name?.data.ID_PARAMETRO,
          };
        },
        fnOk: (value) => {
          const subparametros = getGridParametros().getData(); // viene del backend
          const datos = {
            Bx: pageApi.name.data.bx,
            By: pageApi.name.data.by,
            Bz: pageApi.name.data.bz,
          };
          const formulas = JSON.parse(pageApi.name.data.formulas || "[]");

          const resultados = evaluarFormulasDinamico(
            formulas,
            subparametros,
            datos,
          );
          subparametros.forEach((el) => {
            if (resultados[el.id_sub_parametro]) {
              getGridParametros().updateItem({
                ...el,
                resultado: resultados[el.id_sub_parametro].toFixed(9),
              });
            }
          });
        },
      },
      save: {
        queryId: 927,
      },
      fields: [
        { name: "sub_parametro", label: "Sub Parámetro" },
        {
          type: "select",
          name: "um_id",
          label: "Unidad Medida",
          labelName: "desUM",
          column: 4,
          search: true,
          editable: true,
          load: {
            queryId: 583,
            params: () => {
              return {
                id_metodo: pageApi.name.data.id_metodo,
              };
            },
          },
        },
        {
          type: "text",
          name: "resultado",
          label: "Resultado",
          editable: true,
          onChange: (value, values, formApi) => {
            if (
              pageApi?.name?.data.aplica_validacion_radiacion &&
              pageApi?.name?.aplica_formula
            ) {
              let item = formApi.getData();
              let data = getGridParametros().getData();
              let value_dividendo = item.dividendo
                ? item
                : data.find((el) => el.dividendo);
              let value_divisor = item.divisor
                ? item
                : data.find((el) => el.divisor);

              let data_alter = data.map((el) => {
                if (el.cociente) {
                  let result = calcResultRadiacion({
                    dividendo: value_dividendo.resultado,
                    divisor: value_divisor.resultado,
                  });
                  return {
                    ...el,
                    resultado: result.toString(),
                  };
                } else {
                  return el;
                }
              });

              let data_cociente = data_alter.find((el) => el.cociente);
              getGridParametros().updateItem({ ...data_cociente });
              getGridParametros().refresh();
            }

            if (esValidoNumero(values.resultado)) {
              let variable_incertidumbre = JSON.parse(
                getGridParametros()?.itemEditing?.variable_incertidumbre ||
                  "[]",
              );
              let resultado = values.resultado.replace(",", ".");

              if (
                getGridParametros().itemEditing.id_ia_param ==
                  formApi.values.id_ia_param &&
                variable_incertidumbre[0]?.flg_asociado
              ) {
                let ejecutar_operacion = "";
                let efectuar_operaciones_ma = (op) => {
                  if (op.tipo == "Fórmula" && op.tipo_variable == "Simple") {
                    let valor = 0;
                    variable_incertidumbre.forEach((x) => {
                      if (x.id_variable_incertidumbre == op.operacion) {
                        valor = x.valor;
                      }
                    });
                    ejecutar_operacion += valor;
                  } else if (
                    op.tipo == "Fórmula" &&
                    op.tipo_variable == "Calculado"
                  ) {
                    op.operacion_interna.forEach((on1) => {
                      efectuar_operaciones_ma(on1);
                    });
                  } else if (
                    op.tipo == "Sistema" &&
                    op.operacion == "Resultado"
                  ) {
                    ejecutar_operacion += " " + resultado;
                  } else if (op.tipo == "Operador" && op.operacion == "|x|") {
                    //tipo = Operador Valor Absoluto
                    ejecutar_operacion += " Math.abs";
                  } else if (op.tipo == "Operador" && op.operacion == "log") {
                    //tipo = Operador Logaritmo
                    ejecutar_operacion += " Math.log";
                  } else if (op.tipo == "Operador" && op.operacion == "x^") {
                    //tipo = Operador Potencia
                    ejecutar_operacion += " Math.pow";
                  } else if (op.tipo == "Operador" && op.operacion == "√x") {
                    //tipo = Operador Raiz Cuadrada
                    ejecutar_operacion += " Math.sqrt";
                  } else {
                    //tipo = Valor, Operador
                    ejecutar_operacion += " " + op.operacion;
                  }
                };
                variable_incertidumbre.forEach((v) => {
                  if (v.flg_asociado) {
                    ejecutar_operacion = "";
                    v.operaciones.forEach((op) => {
                      efectuar_operaciones_ma(op);
                    });
                    if (v.tipo_variable == "Calculado") {
                      v.valor =
                        evaluacion_aritmetica_incertidumbre_ma(
                          ejecutar_operacion,
                        );
                    }
                    formApi?.setFieldData("resultado", values.resultado);
                    formApi?.setFieldData(
                      "incertidumbre",
                      parseFloat(v.valor).toFixed(v.cantidad_decimales),
                    );
                    getGridParametros().refresh();
                  }
                });
              }
            } else {
              formApi?.setFieldData("incertidumbre", "");
            }
          },
        },
        {
          name: "incertidumbre",
          label: "Incertidumbre",
          editable: true,
        },
        {
          label: (
            <Space size="middle">
              <Upload {...propsFile}>
                <Button
                  type="text"
                  shape="circle"
                  icon={ICON.EXCEL}
                  style={{ color: "green" }}
                />
              </Upload>
              <Button
                type="text"
                shape="circle"
                icon={ICON.COPY}
                style={{ color: "green" }}
                onClick={() => pageApi.showModal(ConfiguracionModalConfig())}
              />
            </Space>
          ),
          color: "green",
          with: 5,
        },
      ],
    };

    return (
      <>
        <GridFw
          name="parametrosGrid"
          getParentApi={pageApi.getApi}
          config={gridConfig}
        />
        <BarButtonFw
          name="agregarButton"
          getParentApi={pageApi.getApi}
          config={barHeaderConfig}
        />
      </>
    );
  }
}
